import { CalculatePriceResponse } from '@/src/lib/product/types';
import { CalculatePriceRequestData } from '@/src/app/api/calculate-price/route';
import { postCalculatePrice } from '@/src/lib/product/requests/post-calculate-price';

export async function calculatePriceClient(request: CalculatePriceRequestData): Promise<CalculatePriceResponse> {
  return await postCalculatePrice(request);
}
